export const types = {
  SET_PRODUCTS: 'SET_PRODUCTS',
  SET_AGGREGATIONS: 'SET_AGGREGATIONS',
  SET_PRODUCTS_SORT: 'SET_PRODUCTS_SORT',
  SET_CATEGORY: 'SET_CATEGORY',
  SET_ARTICLES: 'SET_ARTICLES',
  SET_PRODUCT_TOTAL_COUNT: 'SET_PRODUCT_TOTAL_COUNT',
  SET_PRODUCT_TOTAL_PAGES: 'SET_PRODUCT_TOTAL_PAGES',
  SET_PER_PAGE: 'SET_PER_PAGE',
  UPDATE_FILTERS: 'UPDATE_FILTERS',
  IS_PENDING: 'IS_PENDING',
  SET_QUERY: 'SET_QUERY',
  SET_CLICKED_FROM_HEADER_SEARCH: 'SET_CLICKED_FROM_HEADER_SEARCH',
}
